import Box from '@mui/material/Box';
import { addDays } from 'date-fns/addDays';
import { isSunday } from 'date-fns/isSunday';
import ErrorBox from '../../core/components/ErrorBox';
import useProperty from '../../property/hooks/useProperty';
import useCleaningState from '../hooks/useCleaningState';
import AutoAddCleaningButton from './AutoAddCleaningButton';

function CleaningWidget() {
    const { isCleaningEnabled, propertyId, loading: propertyLoading } = useProperty();
    const { error, loading, data } = useCleaningState({
        params: [propertyId ?? 0],
        skip: !propertyId,
    });

    if (propertyLoading || loading) {
        return null;
    }

    if (!isCleaningEnabled()) {
        return null;
    }

    if (error) {
        return <ErrorBox error={error} />;
    }

    const { bookingsWithoutCleaning, closestBookings, total } = data;

    return (
        <Box>
            Cleaning owed: {total}
            <Box display="flex" flexDirection="column" gap={2}>
                {bookingsWithoutCleaning.map(booking => {
                    const isOnInconvenientDay =
                        isSunday(booking.checkout) ||
                        booking.checkout.slice(5, 10) === '01-01';

                    if (isOnInconvenientDay) {
                        const targetDate = addDays(booking.checkout, 1)
                            .toISOString()
                            .slice(0, 10);
                        let closestBooking = closestBookings.find(
                            item => item.checkin >= targetDate
                        );

                        return (
                            <div
                                className="flex gap-5 items-center"
                                key={booking.id}
                            >
                                <div className="whitespace-nowrap">
                                    {booking.guestName} {booking.checkout} -&gt;{' '}
                                    {targetDate} Correction, Next:{' '}
                                    {closestBooking?.checkin}
                                    {closestBooking?.checkin === targetDate && (
                                        <>CONFLICT</>
                                    )}
                                </div>
                                <AutoAddCleaningButton
                                    time={`${targetDate} ${booking.checkoutTime}`}
                                />
                            </div>
                        );
                    }

                    return (
                        <div
                            className="flex gap-5 items-center"
                            key={booking.id}
                        >
                            <div className="whitespace-nowrap">
                                {booking.guestName} {booking.checkout}
                            </div>
                            <AutoAddCleaningButton
                                time={`${booking.checkout} ${booking.checkoutTime}`}
                            />
                        </div>
                    );
                })}
            </Box>
        </Box>
    );
}

export default CleaningWidget;
